import classNames from 'classnames';
import React, { ReactNode, useCallback, useEffect, useState } from 'react';
import './InputMaxLength.scss';

type InputMaxLengthProps = {
  children: ReactNode;
  detailChildren?: ReactNode;
  max: number;
  value: string | undefined;
  css?: {
    container?: string;
    details?: string;
  };
};

export const InputMaxLength = ({
  children,
  detailChildren,
  max,
  value,
  css,
}: InputMaxLengthProps) => {
  const [length, setLength] = useState((value && value.length) || 0);

  const callback = useCallback(e => {
    if (e.target.value.length > max) {
      e.target.value = e.target.value.substr(0, max);
      e.preventDefault();
      e.stopPropagation();
    }
    setLength(e.target.value.length);
  }, []);

  useEffect(() => {
    setLength((value && value.length) || 0);
  }, [value]);

  return (
    <div
      className={classNames('input-max-length', css?.container)}
      onInput={callback}
    >
      {children}
      <div
        className={classNames('input-max-length__details', css?.details, {
          'input-max-length__details--error': length > max,
        })}
      >
        {length}/{max}
        {detailChildren}
      </div>
    </div>
  );
};
